module.exports = __webpack_public_path__ + "static/media/caigouliucheng61.55c8daca.png";